import { render } from "./guide1.vue?vue&type=template&id=2e94101f&ts=true"
import script from "./guide1.vue?vue&type=script&lang=ts"
export * from "./guide1.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__